export default {
  days: {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  },
  types: {
    habitual: "Regular",
    occasional: "Occasional",
    blocked: "Blocked",
  },
  appointmentTypes: {
    private: "Private",
    insurance: "Insurance",
  },
  consultationModes: {
    in_person: "In person",
    virtual: "Virtual",
    both: "In person and virtual",
  },
  consultationModeLabel: "Consultation format",
  consultationModeBothOption: "Both",
  consultationModeHint: "If you choose \"Both\", the patient or secretary picks the format when booking.",
  consultationModeChoose: "Appointment format *",
  consultationModeRequired: "Choose whether the appointment is in person or virtual",
  weekPrevious: "Previous week",
  weekNext: "Next week",
  weekOf: "Week of",
};
